import React, { useEffect, useState } from "react";
import { useParams, NavLink } from "react-router-dom";
import { GiBrokenPottery, GiSpinningWheel } from "react-icons/gi";
import { PiWarningDiamondFill } from "react-icons/pi";

import { usePaymentsContext } from "../../contexts/PaymentsContextProvider";
import { useUserContext } from "../../contexts/UserContextProvider";
import { convertUnixTimestampToDateTime } from "../../components/utils/timeStampConversion";
import appLogo from "../../images/logo/logo-192px.png";

const OrderPaymentResponse = () => {
  const { orderId, phoneNumberId } = useParams();
  const { orderPaymentDetailsById, isLoading } = usePaymentsContext();
  const [orderPaymentDetails, setOrderPaymentDetails] = useState([]);
  const { loginCheck } = useUserContext();

  const loadPaymentDetails = async () => {
    const result = await orderPaymentDetailsById(orderId, phoneNumberId);
    setOrderPaymentDetails(result);
  };

  const refreshPage = () => {
    window.location.reload();
  };

  useEffect(() => {
    loadPaymentDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {}, [orderPaymentDetails]);

  return (
    <div className="h-screen flex flex-col justify-between">
      <div className="bg-wabmBlue w-full h-2" />
      <main className="space-y-5">
        {orderPaymentDetails?.length > 0 ? (
          orderPaymentDetails?.map((payment, index) => {
            const paymentDate = convertUnixTimestampToDateTime(
              payment?.paymentTimeStamp / 1000
            );
            if (payment?.paymentStatus === "paid") {
              return (
                <div
                  key={index}
                  className="flex flex-col justify-center items-center gap-1"
                >
                  <img
                    src={appLogo}
                    alt="WaBM WA API"
                    className="w-24 mx-auto mb-5"
                  />
                  <h2 className="text-xl font-semibold">Payment Successful</h2>
                  <p>Thanks for purchasing items</p>

                  <div className="my-5 p-5 grid grid-cols-2 gap-2 border border-slate-300 rounded-md">
                    <h4 className="border-r border-slate-300">
                      Payment Status
                    </h4>
                    <p>{payment?.paymentStatus}</p>

                    <h4 className="border-r border-slate-300">Payment Id</h4>
                    <p>{payment?.paymentDetails.paymentId}</p>

                    <h4 className="border-r border-slate-300">Payment Date</h4>
                    <p>{paymentDate}</p>

                    <h4 className="border-r border-slate-300">
                      Payment Amount
                    </h4>
                    <p>{payment?.orderAmount.toFixed(2)}</p>

                    <h4 className="border-r border-slate-300">Order ID</h4>
                    <p>{payment?.orderId}</p>

                    <h4 className="border-r border-slate-300">
                      Payment Method
                    </h4>
                    <p>{payment?.paymentDetails.paymentMethod}</p>
                  </div>

                  <NavLink to="/login">
                    <button onClick={loginCheck} className="my-button-style-1">
                      ⇐ Back to WaBM
                    </button>
                  </NavLink>
                </div>
              );
            } else {
              return (
                <div
                  key={index}
                  className="flex flex-col justify-center items-center gap-1"
                >
                  <PiWarningDiamondFill size={64} className="text-amber-300" />

                  <h2 className="text-xl font-semibold">Payment in Progress</h2>
                  <p>
                    Payment is in progress, please check the status after
                    sometime.
                  </p>

                  <NavLink to="/login">
                    <button
                      onClick={loginCheck}
                      className="my-button-style-1 mt-1"
                    >
                      ⇐ Back to WaBM
                    </button>
                  </NavLink>

                  <button
                    onClick={refreshPage}
                    className="my-button-style-1 mt-1"
                  >
                    ↻ Refresh
                  </button>
                </div>
              );
            }
          })
        ) : (
          <>
            {isLoading === 1 ? (
              <div className="flex flex-col justify-center items-center gap-1">
                <GiBrokenPottery size={64} className="text-red-500" />
                <h2 className="text-xl font-semibold">Are you Lost?</h2>
                <p>Looks like you're trying to access Invalid Page</p>

                <NavLink to="/login">
                  <button
                    onClick={loginCheck}
                    className="my-button-style-1 mt-1"
                  >
                    ⇐ Back to WaBM
                  </button>
                </NavLink>
              </div>
            ) : (
              <div className="flex flex-col justify-center items-center gap-1">
                <GiSpinningWheel size={64} className="text-blue-600" />
                <p>Loading....</p>
              </div>
            )}
          </>
        )}
      </main>

      <div className="bg-wabmBlue w-full h-2" />
    </div>
  );
};
export default OrderPaymentResponse;
